/**
 * 消息推送模板路由
 * @author liu_ning12556
 */
import AsyncComponent from "@/utils/asyncComponent.jsx";

const AsyncImport = (pageStr) => {
    /**
     * webpackChunkName 根据后面的变量引入失效，先这样按照hash打包输出
     */
    return AsyncComponent(
        () =>
            import(
                /* webpackChunkName: "[request]" */ `@/pages/message-push-template/${pageStr}`
            ),
    );
};

export const messagePushTemplete = [
    {
        path: "/oversea/b10/content-text-image",
        component: AsyncImport(
            "oversea/b10/content-template/content-text-image",
        ),
        pathName: "海外b10文本图片消息",
    },
    {
        path: "/oversea/b10/content-text",
        component: AsyncImport("oversea/b10/content-template/content-text"),
        pathName: "海外b10文本消息",
    },
    {
        path: "/oversea/b10/content-image",
        component: AsyncImport("oversea/b10/content-template/content-image"),
        pathName: "海外b10图片消息",
    },
    {
        path: "/oversea/c10/thumb-h-btn",
        component: AsyncImport("oversea/c10/thumb-template/thumb-h-btn"),
        pathName: "海外C10带有按钮的缩略",
    },
    {
        path: "/oversea/c10/content-text-image",
        component: AsyncImport(
            "oversea/c10/content-template/content-text-image",
        ),
        pathName: "海外C10文本图片配置内容",
    },
    {
        path: "/oversea/c10/content-text",
        component: AsyncImport("oversea/c10/content-template/content-text"),
        pathName: "海外C10文本内容",
    },
    {
        path: "/oversea/c10/content-image",
        component: AsyncImport("oversea/c10/content-template/content-image"),
        pathName: "海外C10图片内容",
    },
    {
        path: "/b10/content-service-survey",
        component: AsyncImport("b10/content-template/content-service-survey"),
        pathName: "b10问卷调查",
    },
    {
        path: "/b10/content-text-image",
        component: AsyncImport("b10/content-template/content-text-image"),
        pathName: "b系文本图片配置内容",
    },
    {
        path: "/b10/content-text",
        component: AsyncImport("b10/content-template/content-text"),
        pathName: "b系文本内容",
    },
    {
        path: "/b10/content-image",
        component: AsyncImport("b10/content-template/content-image"),
        pathName: "b系图片内容",
    },
    {
        path: "/b/thumb-h-btn",
        component: AsyncImport("b/thumb-template/thumb-h-btn"),
        pathName: "b系带有按钮的缩略",
    },
    {
        path: "/b/thumb-wechat",
        component: AsyncImport("b/thumb-template/thumb-wechat"),
        pathName: "b系微信缩略内容",
    },
    {
        path: "/b/thumb-location",
        component: AsyncImport("b/thumb-template/thumb-location"),
        pathName: "b系位置消息缩略内容",
    },
    {
        path: "/b/content-service-survey",
        component: AsyncImport("b/content-template/content-service-survey"),
        pathName: "b系问卷调查",
    },
    {
        path: "/b/content-immovable-feasts",
        component: AsyncImport("b/content-template/content-immovable-feasts"),
        pathName: "b系固定节日",
    },
    {
        path: "/b/content-birthday",
        component: AsyncImport("b/content-template/content-birthday"),
        pathName: "b系生日祝福",
    },
    {
        path: "/b/content-wechat",
        component: AsyncImport("b/content-template/content-wechat"),
        pathName: "b系微信内容",
    },
    {
        path: "/b/content-location",
        component: AsyncImport("b/content-template/content-location"),
        pathName: "b系位置消息内容",
    },
    {
        path: "/b/content-text-image",
        component: AsyncImport("b/content-template/content-text-image"),
        pathName: "b系文本图片配置内容",
    },
    {
        path: "/b/content-text",
        component: AsyncImport("b/content-template/content-text"),
        pathName: "c系文本内容",
    },
    {
        path: "/b/content-image",
        component: AsyncImport("b/content-template/content-image"),
        pathName: "b系图片内容",
    },
    {
        path: "/t/thumb-h-btn",
        component: AsyncImport("t03/thumb-template/thumb-h-btn"),
        pathName: "t03带有按钮的缩略",
    },
    {
        path: "/t/content-text",
        component: AsyncImport("t03/content-template/content-text"),
        pathName: "t03文本内容",
    },
    {
        path: "/t/content-birthday",
        component: AsyncImport("t03/content-template/content-birthday"),
        pathName: "t03生日祝福",
    },
    {
        path: "/t/content-duanwu",
        component: AsyncImport("t03/content-template/content-duanwu"),
        pathName: "t03端午",
    },
    {
        path: "/t/content-national-day",
        component: AsyncImport("t03/content-template/content-national-day"),
        pathName: "t03国庆",
    },
    {
        path: "/t/content-national-subsidy",
        component: AsyncImport("t03/content-template/content-national-subsidy"),
        pathName: "t03国补车辆短信推送",
    },
    {
        path: "/t/content-immovable-feasts",
        component: AsyncImport("t03/content-template/content-immovable-feasts"),
        pathName: "t03固定节日",
    },
    {
        path: "/c/content-application-upgrade",
        component: AsyncImport(
            "c/content-template/content-application-upgrade",
        ),
        pathName: "c高德地图应用升级",
    },
    {
        path: "/c/content-national-subsidy",
        component: AsyncImport("c/content-template/content-national-subsidy"),
        pathName: "c国补车辆短信推送",
    },
    {
        path: "/c/content-extended-range-driver-weekly",
        component: AsyncImport(
            "c/content-template/content-extended-range-driver-weekly",
        ),
        pathName: "c系增程驾驶周报",
    },
    {
        path: "/c/fullScreen/content-extended-range-driver-weekly",
        component: AsyncImport(
            "c/fullscreen-content-template/content-extended-range-driver-weekly",
        ),
        pathName: "c系增程驾驶周报(全屏)",
    },
    {
        path: "/c/content-driver-weekly",
        component: AsyncImport("c/content-template/content-driver-weekly"),
        pathName: "c系驾驶周报",
    },
    {
        path: "/c/fullScreen/content-driver-weekly",
        component: AsyncImport(
            "c/fullscreen-content-template/content-driver-weekly",
        ),
        pathName: "c系驾驶周报(全屏)",
    },
    {
        path: "/c/fullScreen/content-application-upgrade",
        component: AsyncImport(
            "c/fullscreen-content-template/content-application-upgrade",
        ),
        pathName: "c高德地图应用升级(全屏)",
    },
    {
        path: "/c/fullScreen/content-zero-hearing",
        component: AsyncImport(
            "c/fullscreen-content-template/content-zero-hearing",
        ),
        pathName: "c零听升级(全屏)",
    },
    {
        path: "/c/fullScreen/content-certification",
        component: AsyncImport(
            "c/fullscreen-content-template/content-certification",
        ),
        pathName: "c系实名认证(全屏)",
    },
    {
        path: "/c/fullScreen/content-immovable-feasts",
        component: AsyncImport(
            "c/fullscreen-content-template/content-immovable-feasts",
        ),
        pathName: "c系固定节日(全屏)",
    },
    {
        path: "/c/fullScreen/content-lc",
        component: AsyncImport("c/fullscreen-content-template/content-lc"),
        pathName: "c系乐橙内容(全屏)",
    },
    {
        path: "/c/fullScreen/content-birthday",
        component: AsyncImport(
            "c/fullscreen-content-template/content-birthday",
        ),
        pathName: "c系生日祝福(全屏)",
    },
    {
        path: "/c/fullScreen/content-wechat",
        component: AsyncImport("c/fullscreen-content-template/content-wechat"),
        pathName: "c系微信内容(全屏)",
    },
    {
        path: "/c/fullScreen/content-location",
        component: AsyncImport(
            "c/fullscreen-content-template/content-location",
        ),
        pathName: "c系位置消息内容(全屏)",
    },
    {
        path: "/c/fullScreen/content-text-image",
        component: AsyncImport(
            "c/fullscreen-content-template/content-text-image",
        ),
        pathName: "c系文本图片配置内容(全屏)",
    },
    {
        path: "/c/fullScreen/content-text",
        component: AsyncImport("c/fullscreen-content-template/content-text"),
        pathName: "c系文本内容(全屏)",
    },
    {
        path: "/c/fullScreen/content-image",
        component: AsyncImport("c/fullscreen-content-template/content-image"),
        pathName: "c系图片内容(全屏)",
    },
    {
        path: "/c/fullScreen/content-service-survey",
        component: AsyncImport(
            "c/fullscreen-content-template/content-service-survey",
        ),
        pathName: "c问卷调查(全屏)",
    },
    {
        path: "/c/content-service-survey",
        component: AsyncImport("c/content-template/content-service-survey"),
        pathName: "c问卷调查",
    },
    {
        path: "/c/content-immovable-feasts",
        component: AsyncImport("c/content-template/content-immovable-feasts"),
        pathName: "c系固定节日",
    },
    {
        path: "/c/content-first-frost",
        component: AsyncImport("c/content-template/content-first-frost"),
        pathName: "c系霜降",
    },
    {
        path: "/c/content-national-day",
        component: AsyncImport("c/content-template/content-national-day"),
        pathName: "c系国庆",
    },
    {
        path: "/c/content-autumnal-equinox",
        component: AsyncImport("c/content-template/content-autumnal-equinox"),
        pathName: "c系秋分",
    },
    {
        path: "/c/content-mid-autumn",
        component: AsyncImport("c/content-template/content-mid-autumn"),
        pathName: "c系中秋",
    },
    {
        path: "/c/content-white-dew",
        component: AsyncImport("c/content-template/content-white-dew"),
        pathName: "c系白露",
    },
    {
        path: "/c/content-limit-heat",
        component: AsyncImport("c/content-template/content-limit-heat"),
        pathName: "c系处暑",
    },
    {
        path: "/c/content-certification",
        component: AsyncImport("c/content-template/content-certification"),
        pathName: "c系实名认证",
    },
    {
        path: "/c/content-zero-hearing",
        component: AsyncImport("c/content-template/content-zero-hearing"),
        pathName: "c系零听升级",
    },
    {
        path: "/c/content-autumn-begins",
        component: AsyncImport("c/content-template/content-autumn-begins"),
        pathName: "c系立秋",
    },
    {
        path: "/c/content-great-heat",
        component: AsyncImport("c/content-template/content-great-heat"),
        pathName: "c系大暑",
    },
    {
        path: "/c/content-slight-heat",
        component: AsyncImport("c/content-template/content-slight-heat"),
        pathName: "c系小暑",
    },
    {
        path: "/c/content-summer-solstice",
        component: AsyncImport("c/content-template/content-summer-solstice"),
        pathName: "c系夏至",
    },
    {
        path: "/c/content-birthday",
        component: AsyncImport("c/content-template/content-birthday"),
        pathName: "c系生日祝福",
    },
    {
        path: "/c/content-duanwu",
        component: AsyncImport("c/content-template/content-duanwu"),
        pathName: "c系端午",
    },
    {
        path: "/c/text-template",
        component: AsyncImport("c/text-template"),
        pathName: "c系文本模板",
    },
    {
        path: "/c/text-template-content",
        component: AsyncImport("c/text-template-content"),
        pathName: "c系文本模板内容",
    },
    {
        path: "/c/thumb-certification",
        component: AsyncImport("c/thumb-template/thumb-certification"),
        pathName: "c系实名认证的缩略",
    },
    {
        path: "/c/fullScreen/thumb-certification",
        component: AsyncImport(
            "c/fullscreen-thumb-template/thumb-certification",
        ),
        pathName: "c系实名认证的缩略(全屏)",
    },
    {
        path: "/c/fullScreen/thumb-h-btn",
        component: AsyncImport("c/fullscreen-thumb-template/thumb-h-btn"),
        pathName: "c系带有按钮的缩略(全屏)",
    },
    {
        path: "/c/fullScreen/thumb-wechat",
        component: AsyncImport("c/fullscreen-thumb-template/thumb-wechat"),
        pathName: "c系微信缩略内容(全屏)",
    },
    {
        path: "/c/fullScreen/thumb-lc",
        component: AsyncImport("c/fullscreen-thumb-template/thumb-lc"),
        pathName: "c系乐橙缩略内容(全屏)",
    },
    {
        path: "/c/fullScreen/thumb-location",
        component: AsyncImport("c/fullscreen-thumb-template/thumb-location"),
        pathName: "c系位置消息缩略内容(全屏)",
    },
    {
        path: "/c/thumb-h-btn",
        component: AsyncImport("c/thumb-template/thumb-h-btn"),
        pathName: "c系带有按钮的缩略",
    },
    {
        path: "/c/thumb-wechat",
        component: AsyncImport("c/thumb-template/thumb-wechat"),
        pathName: "c系微信缩略内容",
    },
    {
        path: "/c/thumb-lc",
        component: AsyncImport("c/thumb-template/thumb-lc"),
        pathName: "c系乐橙缩略内容",
    },
    {
        path: "/c/thumb-weekreport",
        component: AsyncImport("c/thumb-template/thumb-weekreport"),
        pathName: "c系周报缩略内容",
    },
    {
        path: "/c/thumb-image",
        component: AsyncImport("c/thumb-template/thumb-image"),
        pathName: "c系图片缩略内容",
    },
    {
        path: "/c/thumb-video",
        component: AsyncImport("c/thumb-template/thumb-video"),
        pathName: "c系视频缩略内容",
    },
    {
        path: "/c/test-apigateway",
        component: AsyncImport("c/content-template/test-apigateway"),
        pathName: "c系视频缩略内容",
    },
    {
        path: "/c/content-wechat",
        component: AsyncImport("c/content-template/content-wechat"),
        pathName: "c系微信内容",
    },
    {
        path: "/c/content-lc",
        component: AsyncImport("c/content-template/content-lc"),
        pathName: "c系乐橙内容",
    },
    {
        path: "/c/content-weekreport",
        component: AsyncImport("c/content-template/content-weekreport"),
        pathName: "c系周报内容",
    },
    {
        path: "/c/content-image",
        component: AsyncImport("c/content-template/content-image"),
        pathName: "c系图片内容",
    },
    {
        path: "/c/content-video",
        component: AsyncImport("c/content-template/content-video"),
        pathName: "c系视频内容",
    },
    {
        path: "/c/content-text-image",
        component: AsyncImport("c/content-template/content-text-image"),
        pathName: "c系文本图片配置内容",
    },
    {
        path: "/c/content-text",
        component: AsyncImport("c/content-template/content-text"),
        pathName: "c系文本内容",
    },
    {
        path: "/c/thumb-location",
        component: AsyncImport("c/thumb-template/thumb-location"),
        pathName: "c系位置消息缩略内容",
    },
    {
        path: "/c/content-location",
        component: AsyncImport("c/content-template/content-location"),
        pathName: "c系位置消息内容",
    },
    {
        path: "/c/thumb-function-remind",
        component: AsyncImport("c/thumb-template/thumb-function-remind"),
        pathName: "c系功能提醒缩略内容",
    },
    {
        path: "/c/content-auto-parking",
        component: AsyncImport("c/content-function-remind/auto-parking"),
        pathName: "c系功能提醒自动泊车内容",
    },
    {
        path: "/c/content-voice-play-music",
        component: AsyncImport("c/content-function-remind/voice-play-music"),
        pathName: "c系功能提醒语音播放音乐内容",
    },
    {
        path: "/c/content-voice-control-aircondition",
        component: AsyncImport(
            "c/content-function-remind/voice-control-aircondition",
        ),
        pathName: "c系功能提醒语音控制空调内容",
    },
    {
        path: "/c/content-driver-assistance",
        component: AsyncImport("c/content-function-remind/driver-assistance"),
        pathName: "c系功能提醒辅助驾驶内容",
    },
    {
        path: "/c/content-driving-mode",
        component: AsyncImport("c/content-function-remind/driving-mode"),
        pathName: "c系功能提醒驾驶模式内容",
    },
    {
        path: "/c/content-autohold",
        component: AsyncImport("c/content-function-remind/auto-hold"),
        pathName: "c系功能提醒Autohold内容",
    },
    {
        path: "/c/content-reserve-charging",
        component: AsyncImport("c/content-function-remind/reserve-charging"),
        pathName: "c系功能提醒预约充电内容",
    },
    {
        path: "/c/content-face-recognition",
        component: AsyncImport("c/content-function-remind/face-recognition"),
        pathName: "c系功能提醒人脸识别内容",
    },
];
